import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../constants';

const NotFound = () => {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center bg-white px-6">
      <div className="text-center">
        <h1 className="text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 mb-4">
          404
        </h1>
        <h2 className="text-3xl font-bold text-slate-900 mb-6">
          Oops! You've strayed off the path.
        </h2>
        <p className="text-slate-500 text-lg mb-10 max-w-lg mx-auto">
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back to familiar territory.
        </p>
        <Link 
          to={ROUTES.home || "/"} 
          className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full transition-all shadow-lg hover:shadow-blue-200 active:scale-95"
        >
          Return to Home
        </Link>
      </div>
      <div className="mt-16 w-full max-w-xl mx-auto opacity-20 pointer-events-none">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path fill="#2563EB" d="M47.7,-57.2C59.9,-46.8,66.6,-28.9,67.8,-11.3C68.9,6.3,64.6,23.6,54.1,36.4C43.6,49.2,26.9,57.5,8.8,59.3C-9.3,61.1,-28.9,56.4,-44.6,45.2C-60.3,34,-72.1,16.3,-72.6,-1.7C-73.1,-19.7,-62.3,-38,-47.5,-48.5C-32.7,-59.1,-14.1,-62.1,2.4,-65C18.9,-67.9,35.5,-67.6,47.7,-57.2Z" transform="translate(100 100)" />
        </svg>
      </div>
    </div>
  );
};

export default NotFound;
